<template>
  <footer class="footer-wrapper">
    <div class="footer-container">
      <div class="footer-content">
        <img src="@/assets/cryptopag-logo1.png" alt="Logo" class="footer-logo" />
        <p class="footer-copyright">©2026 All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footerPart",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
.footer-wrapper {
  background-color: #f8f9fa;
  padding: 40px 20px;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.footer-logo {
  height: 160px !important;
  width: auto !important;
}

.footer-copyright {
  font-size: 14px;
  color: #6c757d;
  margin: 0;
}

@media screen and (min-width: 1192px) {
  .footer-logo {
    width: 320px !important;
    height: 90px !important;
  }
}

@media screen and (min-width: 840px) and (max-width: 1192px) {
  .footer-logo {
    width: 280px !important;
    height: 80px !important;
  }
}

@media screen and (min-width: 600px) and (max-width: 839px) {
  .footer-logo {
    width: 260px !important;
    height: 74px !important;
  }
}

@media screen and (max-width: 599px) {
  .footer-logo {
    width: 240px !important;
    height: 68px !important;
  }
}

@media screen and (max-width: 768px) {
  .footer-wrapper {
    padding: 30px 15px;
  }
  
  .footer-logo {
    height: 140px !important;
  }
  
  .footer-copyright {
    font-size: 12px;
  }
}
</style>
